(function() {
  var overlay, modal;

  function buildModal() {
    overlay = document.createElement('div');
    overlay.id = 'dogal-qa-overlay';
    overlay.setAttribute('style', 'position:fixed;inset:0;z-index:10000;background:rgba(5,5,5,0.55);display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .22s;');
    overlay.addEventListener('click', function(e) { if (e.target === overlay) DogalQuickAdd.close(); });
    modal = document.createElement('div');
    modal.id = 'dogal-qa-modal';
    modal.setAttribute('style', 'background:#fff;width:90%;max-width:480px;border-radius:4px;overflow:hidden;transform:translateY(12px);transition:transform .22s;');
    modal.innerHTML = '<div id="dogal-qa-inner"></div>';
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
  }

  window.DogalQuickAdd = {
    open: function(btn) {
      var handle = btn.getAttribute('data-product-handle');
      var title = btn.getAttribute('data-product-title');
      var price = btn.getAttribute('data-product-price');
      var img = btn.getAttribute('data-product-image');
      if (!overlay) buildModal();
      document.getElementById('dogal-qa-inner').innerHTML = [
        '<div style="display:flex;align-items:center;gap:14px;padding:16px 16px 14px;border-bottom:1px solid #eee;">',
          '<img src="' + img + '" style="width:64px;height:80px;object-fit:cover;border-radius:2px;" alt="">',
          '<div style="flex:1;">',
            '<p style="font-size:13px;font-weight:700;color:#111;margin:0 0 4px;letter-spacing:0.02em;">' + title + '</p>',
            '<p style="font-size:13px;color:#555;margin:0;">' + price + '</p>',
          '</div>',
          '<button onclick="DogalQuickAdd.close()" style="background:none;border:none;color:#999;font-size:20px;cursor:pointer;padding:4px;line-height:1;">✕</button>',
        '</div>',
        '<div id="dogal-qa-variants" style="padding:20px 16px 16px;">',
          '<p style="font-size:12px;color:#999;text-align:center;">Yükleniyor...</p>',
        '</div>'
      ].join('');
      overlay.style.display = 'flex';
      requestAnimationFrame(function() { overlay.style.opacity = '1'; modal.style.transform = 'translateY(0)'; });
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) { DogalQuickAdd.renderVariants(p); })
        .catch(function() { document.getElementById('dogal-qa-variants').innerHTML = '<p style="color:#999;text-align:center;">Hata oluştu.</p>'; });
    },

    renderVariants: function(product) {
      var container = document.getElementById('dogal-qa-variants');
      if (!container) return;
      var hasSizes = false;
      product.options.forEach(function(opt) {
        var n = opt.name || opt;
        if (n === 'Beden' || n === 'Size') hasSizes = true;
      });
      if (!hasSizes || product.variants.length <= 1) {
        container.innerHTML = '<button onclick="DogalQuickAdd.addToCart(' + product.variants[0].id + ',this)" style="width:100%;padding:15px;background:#111;color:#fff;border:none;font-size:12px;font-weight:700;letter-spacing:0.18em;text-transform:uppercase;cursor:pointer;border-radius:2px;">Sepete Ekle</button>';
        return;
      }
      var html = '<p style="font-size:12px;color:#999;margin:0 0 12px;">Beden: <span id="dogal-sz" style="color:#111;font-weight:600;">—</span></p>';
      html += '<div style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:20px;">';
      product.variants.forEach(function(v) {
        var ok = v.available;
        html += '<button onclick="DogalQuickAdd.selectSize(this,' + v.id + ',\'' + v.title + '\')" data-vid="' + v.id + '" style="width:50px;height:50px;border-radius:50%;border:1px solid ' + (ok ? '#ccc' : '#e5e5e5') + ';background:#fff;color:' + (ok ? '#111' : '#ccc') + ';font-size:11px;font-weight:600;cursor:' + (ok ? 'pointer' : 'not-allowed') + ';transition:all .15s;"' + (ok ? '' : ' disabled') + '>' + v.title + '</button>';
      });
      html += '</div>';
      html += '<button id="dogal-add" disabled onclick="DogalQuickAdd.addToCart(DogalQuickAdd.sv,this)" style="width:100%;padding:15px;background:#ccc;color:#fff;border:none;font-size:12px;font-weight:700;letter-spacing:0.18em;text-transform:uppercase;cursor:not-allowed;border-radius:2px;transition:all .2s;">Beden Seç</button>';
      container.innerHTML = html;
      DogalQuickAdd.sv = null;
    },

    selectSize: function(btn, vid, title) {
      DogalQuickAdd.sv = vid;
      var el = document.getElementById('dogal-sz');
      if (el) el.textContent = title;
      document.querySelectorAll('#dogal-qa-variants button[data-vid]').forEach(function(b) {
        b.style.background = '#fff';
        b.style.color = '#111';
        b.style.borderColor = '#ccc';
      });
      btn.style.background = '#111';
      btn.style.color = '#fff';
      btn.style.borderColor = '#111';
      var a = document.getElementById('dogal-add');
      if (a) { a.disabled = false; a.style.background = '#111'; a.style.cursor = 'pointer'; a.textContent = 'Sepete Ekle'; }
    },

    addToCart: function(vid, btn) {
      if (!vid) return;
      btn.textContent = 'Ekleniyor...';
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({id: vid, quantity: 1}) })
        .then(function(r) { return r.json(); })
        .then(function(item) {
          var c = document.querySelector('.cart-count');
          if (c) c.textContent = parseInt(c.textContent || 0) + 1;
          var inner = document.getElementById('dogal-qa-inner');
          if (inner) {
            inner.innerHTML = [
              '<div style="background:#f0faf4;padding:12px 16px;display:flex;align-items:center;gap:8px;border-bottom:1px solid #eee;">',
                '<span style="color:#2a9d5c;font-size:18px;">✓</span>',
                '<span style="font-size:13px;font-weight:600;color:#2a9d5c;">Sepete eklendi!</span>',
              '</div>',
              '<div style="display:flex;align-items:center;gap:14px;padding:16px;">',
                '<img src="' + (item.featured_image && item.featured_image.url ? item.featured_image.url : '') + '" style="width:64px;height:80px;object-fit:cover;border-radius:2px;" alt="">',
                '<div>',
                  '<p style="font-size:13px;font-weight:700;color:#111;margin:0 0 4px;">' + item.product_title + '</p>',
                  '<p style="font-size:12px;color:#555;margin:0;">' + (item.price / 100).toFixed(2) + ' TL</p>',
                  '<p style="font-size:12px;color:#999;margin:4px 0 0;">' + item.variant_title + '</p>',
                '</div>',
              '</div>',
              '<div style="display:flex;gap:8px;padding:0 16px 16px;">',
                '<button onclick="DogalQuickAdd.close();CartDrawer.open();" style="flex:1;padding:13px;border:1px solid #ccc;background:#fff;text-align:center;font-size:11px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;color:#111;cursor:pointer;border-radius:2px;">Sepete Git</button>',
                '<a href="/checkout" style="flex:1;padding:13px;background:#111;text-align:center;font-size:11px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;color:#fff;text-decoration:none;border-radius:2px;">Ödemeye Geç</a>',
              '</div>'
            ].join('');
          }
        })
        .catch(function() { btn.textContent = 'Hata — Tekrar Dene'; btn.disabled = false; });
    },

    close: function() {
      if (!overlay) return;
      overlay.style.opacity = '0';
      modal.style.transform = 'translateY(12px)';
      setTimeout(function() { overlay.style.display = 'none'; }, 220);
    }
  };
})();
